<template>
  <div>
    
    <div class="share-container" :class="{ 'visible': visible }">
      <button class="btn btn-white text-blue-ml btn-share" @click="visible = !visible" >
        <ShareVariantIcon class="icon-share" />
      </button>

      <ul>
        <li>
          <button class="btn btn-blue-ml" v-b-tooltip.hover v-b-tooltip.top title="Compartilhar no Facebook" @click="share('facebook')">
            <FacebookIcon title="" />
          </button>
        </li>

        <li>
          <button class="btn btn-blue-ml" v-b-tooltip.hover v-b-tooltip.top title="Compartilhar no Linkedin" @click="share('linkedin')">
            <LinkedinIcon title="" />
          </button>
        </li>

        <li>
          <button class="btn btn-blue-ml" v-b-tooltip.hover v-b-tooltip.top title="Compartilhar no Twitter" @click="share('twitter')">
            <TwitterIcon title="" />
          </button>
        </li>

        <li>
          <button class="btn btn-blue-ml" v-b-tooltip.hover v-b-tooltip.top title="Compartilhar no Whatsapp" @click="share('whatsapp')">
            <WhatsappIcon title="" />
          </button>
        </li>

        <li>
          <button :id="'btnCopy' + _uid" class="btn btn-blue-ml" v-b-tooltip.hover v-b-tooltip.top :title="copyLinkTooltip" @click="share('link')">
            <LinkIcon title="" />
          </button>
        </li>
      </ul>
    </div>

  </div>
</template>

<script>
  import ShareVariantIcon from "vue-material-design-icons/ShareVariant.vue"
  import FacebookIcon from "vue-material-design-icons/Facebook.vue"
  import LinkedinIcon from "vue-material-design-icons/Linkedin.vue"
  import TwitterIcon from "vue-material-design-icons/Twitter.vue"
  import WhatsappIcon from "vue-material-design-icons/Whatsapp.vue"
  import LinkIcon from "vue-material-design-icons/Link.vue"
  export default {
    name: 'SharreJob',
    data() {
      return {
        visible: false,
        copyLinkTooltip: 'Copiar Link'
      }
    },
    props: {
      url: String
    },
    components: {
      ShareVariantIcon,
      FacebookIcon,
      LinkedinIcon,
      TwitterIcon,
      WhatsappIcon,
      LinkIcon
    },
    methods: {
      share(provider){
        var providerUrl = '';
        if(provider == 'facebook'){ providerUrl = 'https://www.facebook.com/sharer/sharer.php?u='; }
        if(provider == 'linkedin'){ providerUrl = 'https://www.linkedin.com/shareArticle?mini=true&url='; }
        if(provider == 'twitter'){ providerUrl = 'http://twitter.com/share?url='; }
        if(provider == 'whatsapp'){ providerUrl = 'https://web.whatsapp.com/send?text='; }
        if(this.OPPORTUNITIES_ENDPOINT.indexOf('staging') !== -1){
          var url = providerUrl + "http://staging-carreiras.99jobs.com//vagas/" + this.url;
        }else{
          var url = providerUrl + "https://carreiras.gusmao-labrunie.com.br/vagas/" + this.url;
        }
        
        if(provider == 'link'){
          var el = document.createElement('textarea');
          el.value = url;
          el.setAttribute('readonly', '');
          el.style.position = 'absolute';
          el.style.left = '-9999px';
          document.body.appendChild(el);
          el.select();
          document.execCommand('copy');
          document.body.removeChild(el);
          
          var tooltipMsg = this.copyLinkTooltip;
          this.copyLinkTooltip = 'Copiado!';
          this.$root.$emit('bv::hide::tooltip');
          setTimeout(() => {
            this.$root.$emit('bv::show::tooltip', 'btnCopy' + this._uid);
          }, 100)
          setTimeout(() => {
            this.copyLinkTooltip = tooltipMsg;
          }, 200)
          return;
        }
        if(provider == 'whatsapp'){
          window.open(url, '_blank');
          return;
        }
        if(provider != 'link'){
          this.$root.$emit('bv::hide::tooltip');
          var title = "Compartilhar Oportunidade";
          var width = 540;
          var height = 600;
          var left = (screen.width - width) / 2;
          var top = (screen.height - height) / 4;
          var myWindow = window.open(url, title, 'toolbar=no, location=no, directories=no, status=no, menubar=no, scrollbars=no, resizable=no, copyhistory=no, width=' + width + ', height=' + height + ', top=' + top + ', left=' + left);
          myWindow.focus();
        }
      }
    },
  }
</script>

<style lang="scss" scoped>
  .share-container{
    position: relative;
    display: inline-flex;
    align-items: center;
   // background: theme-color('blue-br');
    border-radius: 30px;
    border: 2px solid theme-color('blue-br');
    .btn{
      border-radius: 50% !important;
      box-shadow: none !important;
    }
    .btn-share{
      width: 32px;
      height: 32px;
      position: relative;
      z-index: 1;
      /deep/ .material-design-icon > .material-design-icon__svg{
        margin-left: -12px;
        margin-bottom: 6px;
      }
    }
    /deep/ .material-design-icon > .material-design-icon__svg{
      position: absolute !important;
      bottom: -0.125em;
      font-size: 16px;
      margin-left: -12px;
      margin-bottom: 7px;
    }
    ul{
      padding: 0;
      margin: 0;
      display: flex;
      position: relative;
      left: -17px;
      top: 0;
      max-width: 0px;
      overflow: hidden;
      z-index: 0;
      opacity: 0;
      transition: max-width .3s ease-in-out, left .3s ease-in-out, opacity .3s ease-in-out;
      li{
        list-style: none;
        &:first-of-type{
          margin-left: 5px;
        }
        .btn{
          width: 32px;
          height: 32px;
        }
      }
    }
    &.visible{
      ul{
        max-width: 220px;
        left: 0;
        opacity: 1;
      }
    }
  }
</style>